import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/app/operator/nodes")({
  beforeLoad: ({ location }) => {
    throw redirect({
      href: `/app/operator/servers${location.searchStr}${location.hash ? `#${location.hash}` : ""}`,
      replace: true,
    });
  },
});
